import cookieControl from '../../methods/cookieControl'

const convertSelectedFacetsToQueryString = function(facets){

    const prefix = function(string){
        return string.length ? '&' : ''
    }

    let queryString = ''

    for(let facet in facets){
        var keyString = facet
        var facetString = facets[facet].join(',')
        queryString += `${prefix(queryString)}${keyString}=${encodeURIComponent(facetString)}` 
    }

    return queryString

}

const convertSortOptionsToQueryString = function(searchConfig){
    const sortBy = searchConfig.sortBy
    const sortOrder = searchConfig.sortOrder
    let queryString = ''

    if(sortBy && sortOrder){
        queryString = `sortOrder=${sortOrder}&sortBy=${sortBy}&`
    }

    return queryString

}

const createSelectedFacetsObject = function(categories){
    const selectedFacets = {}

    categories.forEach(category => {
        const selectedFacetsArray = category.facets.reduce((total,current)=>{
            if(current.selected){
                total.push(current.key)
            }
            return total
        },[])

        if(selectedFacetsArray.length){
            selectedFacets[category.key] = selectedFacetsArray
        }
    })

    return selectedFacets
}

const formatCategoryViewData = function(response,typeName,groupName,otherFacetGroups){

    const facetsList = response.categories.find(category => category.key === typeName).facets

    const formattedCategory =  {
        key: response.categories.find(category => category.key === typeName).key,
        displayName: response.categories.find(category => category.key === typeName).displayName,
        documentCount: response.categories.find(category => category.key === typeName).hits,
        selected: facetsList.length ? facetsList[0].selected : '',
        value: facetsList.length ? facetsList[0].key : '',
        facetGroups: []
    }

    if(groupName && response.categories.find(category => category.key === groupName)){
        const group = response.categories.find(category => category.key === groupName)
        const products = {
            key: group.key,
            values: group.facets,
            displayName: group.displayName
        }
        formattedCategory.facetGroups.push(products)
    }

    if(otherFacetGroups){
        otherFacetGroups.forEach(groupName =>{
            const group = response.categories.find(category => category.key === groupName)

            formattedCategory.facetGroups.push({
                key: group.key,
                displayName: group.displayName,
                values: group.facets
            })
        })
    }

    return formattedCategory
}

export default {
    namespaced: true,
    state: {
        results : null,
        categories: [],
        selectedFacets: {},
        searchConfig: {
            skip: 0,
            take: 12,
            puid: '00000000-0000-0000-0000-000000000000',
            language: "da"
        },
    },
    mutations:{
        setResults(state,results){
            state.results = results
        },
        setCategories(state,categories){
            state.categories = categories
        },
        clearCategories(state){
            state.categories = []
        },
        setSelectedFacets(state,selectedFacets){
            state.selectedFacets = selectedFacets
        },
        setSearchConfig(state,result){
            delete result.hits
            const newConfig = Object.assign({},state.searchConfig,result)
            state.searchConfig = newConfig
        },
        setPuid(state,puid){
            state.searchConfig.puid = puid
        },
        setLanguageCode(state,lang){
            state.searchConfig.language = lang
        }
    },
    actions:{
        performSearch(context){
            const url = process.env.FILTER_SEARCH
            let config = {}
            
            const searchConfig = Object.assign({},context.state.searchConfig,context.state.selectedFacets)

            config = {
                body: JSON.stringify(searchConfig),
                method: 'POST',
                mode: 'cors',
                headers : {
                    'Content-Type': 'application/json'
                }
            }
        
            return fetch(url,config)
            .then(res => {
                if(res.ok){
                    return res.json()
                } else {
                    throw 'Search error'
                }
            })
            .then(json => context.dispatch('processSearchResponse',json))
            .catch(err => console.error(err))
        },
        processSearchResponse(context,response){
            context.commit('clearCategories')
            context.commit('setResults',response.result.hits.map(hit => hit.content))
            context.commit('setSearchConfig',response.result)
            context.commit('setCategories',[
                formatCategoryViewData(response,'ProductTypeHardware','ProductGroupHardware'),
                formatCategoryViewData(response,'ProductTypeSoftware','ProductGroupSoftware'),
                formatCategoryViewData(response,'ProductTypeCourse','ProductGroupCourse',['CourseLevel','Location']),
                formatCategoryViewData(response,'Industry','Industry'),
                formatCategoryViewData(response,'Manufacturer','Manufacturer'),
            ])
            context.commit('setSelectedFacets',createSelectedFacetsObject(response.categories))
            context.dispatch('composeBrowserUrl')
        },
        composeBrowserUrl(context){
            const facets = context.state.selectedFacets
            const searchConfig = context.state.searchConfig
            const facetString = convertSelectedFacetsToQueryString(facets)
            const pagerString = searchConfig.skip ? `skip=${searchConfig.skip}&` : ''
            const sortString = (pagerString ? '&' : '')+convertSortOptionsToQueryString(searchConfig)

            const queryString = '?'+pagerString+sortString+facetString

            history.replaceState(facets,'search-url',queryString)

            context.dispatch('saveFiltersInCookie',queryString)
        },
        saveFiltersInCookie(context,queryString){
            const expireAt = 86400 // 24 hours
            cookieControl.setItem('shopfilter',decodeURIComponent(queryString),expireAt, '/')
        }

    }
}